import { Send } from 'iconoir-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { BUTTON_TYPES, LANGUAGES } from '@savgroup-front-common/constants';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { LanguageChooser } from '@savgroup-front-common/core/molecules/LanguageChooser';
import { Divider } from '@savgroup-front-common/core/protons/Divider/Divider';
import { ReversioIcon } from '@savgroup-front-common/core/protons/icons';

import {
  $HeaderContainer,
  $MenuContainer,
  $PageWrapper,
} from '../OnboardingSetUp/OnboardingSetUp.styles';

import messages from './messages';
import useResendSalesLeadEmailConfirmationCommand from './OnboardingConfirmation.hooks';
import {
  $AccountActivationTitle,
  $ConfirmationBody,
  $ConfirmationContainer,
  $EmailActivationMessage,
  $IconWithTitle,
  $ResendButton,
  $SpamMessage,
  $UserEmailValue,
  $VerificationMessage,
} from './OnboardingConfirmation.styles';

const OnboardingConfirmation = ({ userEmail }: { userEmail: string }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { handleResendEmail, isLoading } =
    useResendSalesLeadEmailConfirmationCommand({ userEmail });

  useEffect(() => {
    if (!userEmail || userEmail.length === 0) {
      navigate('/onboarding', { replace: true });
    }
  }, [userEmail, navigate]);

  return (
    <$PageWrapper>
      <$HeaderContainer>
        <$MenuContainer>
          <a href="https://www.revers.io">
            <ReversioIcon color={theme.newUI.defaultColors.menu} />
          </a>
          <LanguageChooser acceptedLanguages={[LANGUAGES.FR, LANGUAGES.EN]} />
        </$MenuContainer>
      </$HeaderContainer>
      <$ConfirmationBody>
        <$ConfirmationContainer>
          <$IconWithTitle>
            <Send width={100} color={theme.newUI.defaultColors.primary} />
            <$AccountActivationTitle>
              <SafeFormattedMessageWithoutSpread
                message={messages.accountActivationTitle}
              />
            </$AccountActivationTitle>
          </$IconWithTitle>
          <$VerificationMessage>
            <SafeFormattedMessageWithoutSpread
              message={messages.verification}
            />
          </$VerificationMessage>
          <$EmailActivationMessage>
            <SafeFormattedMessageWithoutSpread
              message={messages.emailActivation}
              values={{
                email: <$UserEmailValue>{userEmail}</$UserEmailValue>,
              }}
            />
          </$EmailActivationMessage>
          <Divider />
          <$SpamMessage>
            <SafeFormattedMessageWithoutSpread message={messages.spam} />
            <$ResendButton
              primary
              type={BUTTON_TYPES.BUTTON}
              onClick={() => handleResendEmail()}
              isLoading={isLoading}
            >
              <SafeFormattedMessageWithoutSpread message={messages.resend} />
            </$ResendButton>
          </$SpamMessage>
        </$ConfirmationContainer>
      </$ConfirmationBody>
    </$PageWrapper>
  );
};

OnboardingConfirmation.displayName = 'OnboardingConfirmation';

export default OnboardingConfirmation;
